import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import UserService from "services/User";
import { addResizedColumns } from "hooks/useTableConfig";
import { CASE_DOMAINS_TABLE_CONSTANTS } from "components/case_domains_table/CaseDomainsTableV3";
import { getCaseDomainsTableColumns } from "components/case_domains_table/CaseDomainsTableColumnsAndFilters";

export const invalidateCaseDomainsQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [CASE_DOMAINS_TABLE_CONSTANTS.queryKey],
  });
};

export const useCaseDomainsTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getCaseDomainsTableColumns();

    const caseDomainsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${CASE_DOMAINS_TABLE_CONSTANTS.tableName}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: caseDomainsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  return { columns };
};
